import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './modules/authentication'
import uploadXml from './modules/uploadXml'
import uploadFile from './modules/uploadFile'
import order from './modules/order'
import sample from './modules/sample'
import result from './modules/result'
import batch from './modules/batch'
import exam from './modules/exam'
import admin from './modules/admin'
import globalModal from './modules/globalModal'
import date from './modules/date'
import comunication from './modules/comunication'
import orderMaintenanceSearch from './modules/orderMaintenanceSearch'
import voucher from './modules/voucher'
import preference from './modules/preference'
import printTag from './modules/printTag'
import tutorial from './modules/tutorial'
import traceabilityStatistics from './modules/traceabilityStatistics'
import traceabilitySearch from './modules/traceabilitySearch'
import serviceToken from './modules/serviceToken'
import recollect from './modules/recollect'
import pendencies from './modules/pendencies'
import reschedule from './modules/reschedule'
import panicAlert from './modules/panicAlert'
import collectionPoint from './modules/collectionPoint'
import examProfile from './modules/examProfiles'
import patient from './modules/patient'
import doctor from './modules/doctor'
import supply from './modules/supply'
import helpCenterTutorials from './modules/helpCenterTutorials'
import billings from './modules/billings'
import resultsPDF from './modules/resultsPDF'
import resultsHistory from './modules/resultsHistory'
import paymentHistory from './modules/paymentHistory'
import userManagement from './modules/userManagement'

import * as actions from './actions'

const debug = process.env.NODE_ENV === 'development'
Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  modules: {
    authentication,
    uploadXml,
    uploadFile,
    order,
    sample,
    result,
    batch,
    exam,
    admin,
    globalModal,
    comunication,
    date,
    orderMaintenanceSearch,
    voucher,
    preference,
    printTag,
    tutorial,
    traceabilityStatistics,
    traceabilitySearch,
    serviceToken,
    recollect,
    pendencies,
    reschedule,
    panicAlert,
    collectionPoint,
    examProfile,
    patient,
    doctor,
    supply,
    helpCenterTutorials,
    billings,
    resultsPDF,
    resultsHistory,
    paymentHistory,
    userManagement
  },
  strict: debug,
  plugins: []
})
